const SkipShipment = (props) => {
  const { clubSubscriptionShipment, onModal } = props;

  const handleSkipShipment = (e) => {
    e.preventDefault();
    onModal('skipSubscriptionShipment');
  };

  const handleUnskipShipment = (e) => {
    e.preventDefault();
    onModal('unskipSubscriptionShipment');
  };

  if (clubSubscriptionShipment.processingStatus === 'Pending') {
    return (
      <a onClick={handleSkipShipment} className="c7-club-actions__skip">
        Skip this shipment
      </a>
    );
  }

  if (clubSubscriptionShipment.processingStatus === 'Skip') {
    return (
      <a onClick={handleUnskipShipment} className="c7-club-actions__unskip">
        Unskip this shipment
      </a>
    );
  }
  return null;
};

export default SkipShipment;
